import { API_ENDPOINT, API_AUTH_ENDPOINT } from './config';

export const urlsAuth = {
  login: `${API_AUTH_ENDPOINT}/login`,
  getUser: `${API_AUTH_ENDPOINT}/user`,
  refresh: `${API_AUTH_ENDPOINT}/refresh-token`,
  logout: `${API_AUTH_ENDPOINT}/logout`,
  impersonate: (personId) => `${API_AUTH_ENDPOINT}/impersonate/${personId}`,
  leaveImpersonation: `${API_AUTH_ENDPOINT}/leave-impersonation`,
  // set sanctum cookie to prevent CSRF
  sanctumCookie: `${API_ENDPOINT}/sanctum/csrf-cookie`,
};
export const routesAuth = {
  loginPage: '/login',
  logout: '/logout',
};
